import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForManualLeafReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyLeafCollectionManualReportSchemaObject } from "../DailyLeafCollectionManualReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import '../Pages/tableFooter.css';
import _ from 'lodash';

const screenCode = "DAILYLEAFCOLLECTIONMANUALLEAFENTRYREPORT";

export function DailyLeafCollectionManualReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalWeight: 0,
        totalNetWeight: 0
    });

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(DailyLeafCollectionManualReportSchemaObject).options({ allowUnknown: true });

    const initialContentRowNames = ["regNo", "name"];
    const initialcsvHeaders = [
        { label: "Reg. Number", value: "regNo" },
        { label: "Reg. Name", value: "name" }
    ];
    const initialColumnNames = ["Reg. Number", "Reg. Name"];

    const [contentRowNames, setContentRowNames] = useState();
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [columnNames, setColumnNames] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [footerData, setFooterData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
        clearTableData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
        clearTableData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableData();
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
        clearTableData();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
        clearTableData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyLeafCollectionManualReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYLEAFCOLLECTIONMANUALLEAFREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getDailyLeafManualReportData(leafCollectionDetails);

        var groupedLeafData = groupLeafDataByCustomerId(result);

        var totalRecord = {
            regNo: "Total",
            name: ""
        };
        var totalRawData = [];

        groupedLeafData.groupedData.forEach(record => {
            for (var property in record) {
                if (!isNaN(property) || property === "total") {
                    totalRecord[property] = (totalRecord[property] === undefined ? 0 : totalRecord[property]) +
                        (record[property] === undefined ? 0 : record[property]);
                    totalRawData.push({ name: property, value: record[property] });
                }
            }
        });

        const calTotalRowData = Array.from(totalRawData.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        setFooterData(calTotalRowData)

        var copyOfContentRowNames = initialContentRowNames;
        var copyCsvHeaders = initialcsvHeaders;
        var copyOfColumnNames = initialColumnNames;
        var copyOfCsvData = _.cloneDeep(groupedLeafData.groupedData);

        groupedLeafData.collectionTypeArray.forEach(x => {
            copyOfContentRowNames.push(x.value);
            copyCsvHeaders.push({ label: x.name, value: x.value });
            copyOfColumnNames.push(x.name);
        });


        copyOfContentRowNames.push("total");
        copyCsvHeaders.push({ label: "Total", value: "total" })
        copyOfColumnNames.push("Total");
        copyOfCsvData.push(totalRecord);


        if (groupedLeafData.groupedData.length > 1) {
            setContentRowNames(copyOfContentRowNames);
            setCsvHeaders(copyCsvHeaders);
            setColumnNames(copyOfColumnNames);
            destroyDataTable();
            setIsTableHide(false);
            setReportData(groupedLeafData.groupedData);
            createDataTable();
            setCsvData(copyOfCsvData);
        }
    }

    function groupLeafDataByCustomerId(data) {

        var collectionTypeArray = [];
        var groupedData = [];

        data.forEach(x => {

            if (groupedData.length === 0) {
                groupedData.push({
                    regNo: x.registrationNumber,
                    name: x.nameToBePrinted,
                    [x.collectionTypeID]: x.totalAmount,
                    total: x.totalAmount,
                    customerID: x.customerID
                });
                collectionTypeArray.push({ value: x.collectionTypeID, name: x.collectionTypeName });
            } else {

                var selectedRecord = groupedData.find(y => y.customerID === x.customerID);

                var isCollectionTypeAvailable = collectionTypeArray.find(y => y.value === x.collectionTypeID);

                if (isCollectionTypeAvailable === undefined) {
                    collectionTypeArray.push({ value: x.collectionTypeID, name: x.collectionTypeName });
                }

                if (selectedRecord) {
                    selectedRecord[x.collectionTypeID] = x.totalAmount;
                    selectedRecord.total += x.totalAmount;

                } else {
                    groupedData.push({
                        regNo: x.registrationNumber,
                        name: x.nameToBePrinted,
                        [x.collectionTypeID]: x.totalAmount,
                        total: x.totalAmount,
                        customerID: x.customerID
                    });
                }
            }
        });

        return {
            groupedData: groupedData,
            collectionTypeArray: collectionTypeArray
        };
    }

    function createDataTable() {
        $("#manualLeafreport").DataTable();
    }

    function destroyDataTable() {
        $("#manualLeafreport").DataTable().destroy();
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Leaf Collection Manual',
            fileName: 'DailyLeafCollectionManualLeafReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            fromDate: "",
            toDate: ""
        });
        clearTableData();
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    function clearTableData() {
        destroyDataTable();
        setIsTableHide(true);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Daily Leaf Collection Manual Leaf Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fromDate">Leaf Collected Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">Day End *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div className="pt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="manualLeafreport" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            {columnNames.map((x, index) => {

                                                                var align = (x === "Reg. Number" || x === "Reg. Name") ? "left" : "right";

                                                                return (
                                                                    <th style={{ textAlign: align }} key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForManualLeafReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={2}>Total</th>
                                                            {contentRowNames.map(x => {
                                                                var equalRecode = footerData.find(y => y.name.toString() === x.toString())
                                                                if (x !== "regNo" && x !== "name") {
                                                                    return(
                                                                        <th style={{textAlign: "right"}}>{equalRecode.value.toFixed(2)}</th>
                                                                    );
                                                                }
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Daily Leaf Collection Manual Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} total={total} footerData={footerData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} columnNames={columnNames} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
